module.exports = __webpack_public_path__ + "static/media/vote-yea.6fada9ca.svg";